import React, { useState, useEffect, useCallback } from "react";
import * as Mui from "@mui/material";
import * as Icons from "@mui/icons-material";
import { EmployeeDetails } from "./EmployeeDetails";
import { CustomTextBox } from "components/CustomComponents/CustomTextBox";
import { themes } from "services/constants";
import { Cancel, Close, AddCircle } from "@material-ui/icons";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { useForm } from "react-hook-form";
import { useFetch } from "services/hooks/useFetch";
import { useSelector } from "react-redux";
import { showToast } from "services/utils/Status";
import {
  CustomButtonWithOutLoader,
  CustomButton,
} from "components/CustomComponents/CustomButton";
import { customAPI } from "services/utils/CustomAPI";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { minimum3Characters } from "services/constants/ErrorMessages";
import { atleastOneCharacterWithSpace } from "services/constants/patterns";
import { EligibilityType } from "../Headers";
import moment from "moment";
import { formText, tooltipStyleProps } from "services/constants/Styles";
import { Info, DateRange } from "@mui/icons-material";

let count = 0;
export const EditIncentive = ({ selectedIncentive, setSelectedComponent }) => {
  const { domain, userScreenAccess } = useSelector(
    (state) => state.tokenReducer
  );
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {
      incentive_name: "",
      criteria_percentage: "",
      criteria_count: "",
      date_changed: false,
      value_changed: false,
      apply_criteria: true,
      get_employee: true,
      get_removed_employee: true,
      get_dept_employee: false,
    },
  });

  const [startDate, setStartDate] = useState(
    moment(selectedIncentive?.start_date)
  );
  const [endDate, setEndDate] = useState(moment(selectedIncentive?.end_date));
  const [rows, setRows] = useState([{ eligiblity_type: "", departments: "" }]);
  const [rowError, setRowError] = useState([
    { eligiblity_type: false, departments: false },
  ]);

  const [openSidePeek, setOpenSidePeek] = useState(false);
  const EmployeeCheck = watch("eligible_employee");
  const QualifiedCheck = watch("qualified_employee");
  const { result: departmentData } = useFetch(`${domain}department/`);
  const { result: designationData } = useFetch(`${domain}designation/`);
  const { result: roleData } = useFetch(
    `${domain}product-control/roles/summary/`
  );
  const { result: individualData } = useFetch(`${domain}user_with_avatar/`);
  const { result: payrollGroupData } = useFetch(`${domain}payroll-group/`);
  const { result: EligibleMetDetials } = useFetch(
    `${domain}application-employees-list/eligible/?application=${selectedIncentive?.id}`
  );
  const [getEmployeeCount, setGetEmployeeCount] = useState([]);
  const [triggerApi, setTriggerApi] = useState(true);
  const [EligibleEmployee, setEligibleEmployee] = useState([]);
  const [eligibleMetEmployee, setEligibleMetEmployee] = useState([]);
  const [qualifiedMembersList, setQualifiedMembersList] = useState([]);
  const [callPostApi, setCallPostApi] = useState(false);
  const [trigerCriteriaApi, setTriggerCriteriaApi] = useState(false);
  const [removedEmployees, setRemovedEmployees] = useState([]);
  const ValueChanged = watch("value_changed");
  const [getEligibleEmployee, setGetEligibleEmployee] = useState(true);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [slapBasedConfigurations, setSlapbasedConfigurations] = useState([
    {
      id: count + 1,
      from_value: "",
      to_value: "",
      amount: "0",
    },
  ]);
  const [fromDateError, setFromDateError] = useState(false);
  const [toDateError, setToDateError] = useState(false);
  const [slabError, setSlabError] = useState(false);
  const [amountError, setAmountError] = useState(false);
  let access_check = checkEditorPermission(
    userScreenAccess?.module_details,
    "Approve",
    "Incentive"
  );
  const qualifiedMembers = watch("qualified_members");
  const IncentiveType = watch("incentive_type");
  const getdeptEmployee = watch("get_dept_employee");

  const departmentList =
    departmentData?.map(({ id, department }) => ({
      id,
      name: department,
    })) ?? [];
  const designationList =
    designationData?.map(({ id, designation }) => ({
      id,
      name: designation,
    })) ?? [];

  const roleList =
    roleData?.map(({ role_id, role_name }) => ({
      id: role_id,
      name: role_name,
    })) ?? [];
  const payrollGroupList =
    payrollGroupData?.map(({ id, name }) => ({
      id,
      name,
    })) ?? [];

  const individualList =
    individualData?.map(({ id, username }) => ({
      id,
      name: username,
    })) ?? [];

  const onSubmit = async (data) => {
    let isValid = await validateRows();
    if (
      isValid &&
      !amountError &&
      !fromDateError &&
      !toDateError &&
      !slabError &&
      eligibleMetEmployee?.length !== 0
    ) {
      setButtonLoader(true);
      const result = {
        departmentIds: [],
        designationIds: [],
      };

      const slap = slapBasedConfigurations.map((data) => ({
        ...data,
        from_value: parseInt(data?.from_value),
        to_value: parseInt(data?.to_value),
        amount: parseFloat(data.amount),
      }));

      rows.forEach((item) => {
        if (item.eligiblity_type === "Department") {
          result.departmentIds = item.departments.map((d) => d.id);
        } else if (item.eligiblity_type === "Designation") {
          result.designationIds = item.departments.map((d) => d.id);
        } else if (item.eligiblity_type === "Role") {
          result.roleIds = item.departments.map((d) => d.id);
        } else if (item.eligiblity_type === "Individual") {
          result.individualIds = item.departments.map((d) => d.id);
        } else if (item.eligiblity_type === "Payrollgroup") {
          result.payrollGroupIds = item.departments.map((d) => d.id);
        }
      });
      let payload = {
        incentive_group: selectedIncentive?.incentive_group,
        payroll_group: selectedIncentive?.payroll_group,
        start_date: startDate.format("YYYY-MM-DD"),
        end_date: endDate.format("YYYY-MM-DD"),
        criteria_type: selectedIncentive?.criteria_type,
        criteria_value:
          selectedIncentive?.calculation_mode === "SLAB" ||
          selectedIncentive?.incentive_type === "Custom"
            ? 100
            : selectedIncentive?.criteria_type === "Percentage"
            ? data?.criteria_percentage
            : data?.criteria_count,
        fixed_amount:
          eligibleMetEmployee?.length === 1 &&
          selectedIncentive?.incentive_type === "Custom"
            ? eligibleMetEmployee[0]?.incentive_amount
            : selectedIncentive?.calculation_mode === "FIXED"
            ? data?.fixed_amount
            : null,
        percentage:
          selectedIncentive?.calculation_mode === "PERCENTAGE"
            ? data?.incentive_percentage
            : null,
        slabs: selectedIncentive?.calculation_mode === "SLAB" ? slap : [],

        eligibilities: {
          DEPARTMENT: result.departmentIds,
          DESIGNATION: result.designationIds,
          ROLE: result.roleIds,
          INDIVIDUAL: result.individualIds,
          PAYROLLGROUP: result.payrollGroupIds,
        },
        employees: eligibleMetEmployee,
        description: data?.reason_for_incentive,
      };
      const response = await customAPI(
        `${domain}incentive-applications/${selectedIncentive?.id}/`,
        "PUT",
        payload
      );
      if (response.ok) {
        showToast("success", "Incentive details updated successfully");
        setRows([{ eligiblity_type: "", departments: "" }]);
        setValue("reason_for_incentive", "");
        setSelectedComponent("Pending");

        setButtonLoader(false);
      }
    } else {
      if (eligibleMetEmployee?.length === 0) {
        showToast(
          "error",
          "No employees meet the eligibility criteria for the incentive group."
        );
      }
    }
    setButtonLoader(false);
  };

  const handleCallback = async (startDate, endDate) => {
    setStartDate(startDate);
    setEndDate(endDate);
    setCallPostApi(true);
    setValue(
      "value_changed",
      selectedIncentive?.incentive_type === "Custom" ? false : true
    );
    setValue("apply_criteria", false);
  };

  const label =
    startDate.format("DD/MM/YYYY") + " - " + endDate.format("DD/MM/YYYY");

  const validateRows = useCallback(() => {
    const newErrors = rows.map((row, index) => {
      const minEmpty = row.eligiblity_type === "";
      const compEmpty = row.departments?.length === 0;
      return {
        eligiblity_type: minEmpty,
        departments: compEmpty,
      };
    });

    const hasError = newErrors.some(
      (err) => err.eligiblity_type || err.departments
    );

    setRowError(newErrors);
    return !hasError;
  }, [rows]);

  const handleAddRow = () => {
    const isValid = validateRows();
    if (!isValid) return;

    setRows((prev) => [...prev, { eligiblity_type: "", departments: "" }]);
    setRowError((prev) => [
      ...prev,
      { eligiblity_type: false, departments: false },
    ]);
  };

  const handleRemoveRow = (index) => {
    setRows((prev) => prev.filter((_, i) => i !== index));
    setRowError((prev) => prev.filter((_, i) => i !== index));
  };

  const handleChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
    setValue("get_dept_employee", true);
    setCallPostApi(true);
    setValue(
      "value_changed",
      selectedIncentive?.incentive_type === "Custom" ? false : true
    );
    setValue("apply_criteria", false);
    const updatedErrors = [...rowError];
    if (!updatedErrors[index])
      updatedErrors[index] = { eligiblity_type: false, departments: false };
    updatedErrors[index][field] = false;
    setRowError(updatedErrors);
  };

  const updatedReasonForOvertime = (event) => {
    if (event.target.value.length <= 1024) {
      setValue("reason_for_incentive", event.target.value);
    }
  };

  const handleCritriaCount = (event) => {
    const validPattern = /^\d{1,3}(\.\d{0,2})?$/;
    if (validPattern.test(event.target.value) || event.target.value === "") {
      setValue("criteria_count", event.target.value);
      setValue("apply_criteria", false);
      setValue("value_changed", true);
    }
  };

  const handleCritriaPercentage = (event) => {
    const validPattern = /^(100(\.0{0,2})?|(\d{1,2})(\.\d{0,2})?)$/;
    if (validPattern.test(event.target.value) || event.target.value === "") {
      setValue("criteria_percentage", event.target.value);
      setValue("apply_criteria", false);
      setValue("value_changed", true);
    }
  };

  useEffect(() => {
    if (selectedIncentive?.eligibility_summary && triggerApi) {
      const summary = selectedIncentive.eligibility_summary;
      const mappedRows = Object.entries(summary)
        .filter(([, value]) => Array.isArray(value) && value.length > 0)
        .map(([key, value]) => ({
          eligiblity_type:
            key.charAt(0).toUpperCase() + key.slice(1).toLowerCase(),
          departments: value,
        }));
      setValue("incentive_name", selectedIncentive?.incentive_name);
      setValue("criteria_percentage", selectedIncentive?.criteria_value ?? "");
      setValue("criteria_type", selectedIncentive?.criteria_type);
      setValue("criteria_count", selectedIncentive?.criteria_value ?? "");
      setValue("reason_for_incentive", selectedIncentive?.description ?? "");
      setValue("fixed_amount", selectedIncentive?.fixed_amount);
      setValue("incentive_percentage", selectedIncentive?.percentage);
      setValue("mode", selectedIncentive?.calculation_mode);
      setValue("incentive_type", selectedIncentive?.incentive_type);
      setValue("custom_amount", selectedIncentive?.fixed_amount);
      setGetEmployeeCount(selectedIncentive);
      setStartDate(moment(selectedIncentive?.start_date));
      setEndDate(moment(selectedIncentive?.end_date));
      setTriggerApi(false);
      setCallPostApi(true);
      setTriggerCriteriaApi(true);
      setRows(mappedRows);
      if (selectedIncentive?.calculation_mode === "SLAB") {
        setSlapbasedConfigurations(selectedIncentive?.slabs);
      } else {
        setSlapbasedConfigurations([
          {
            id: count + 1,
            from_value: "",
            to_value: "",
            amount: "0",
          },
        ]);
      }
    }
  }, [endDate, selectedIncentive, setValue, startDate, triggerApi]);

  useEffect(() => {
    const togetEligibleEmployess = async () => {
      let isValid = await validateRows();
      if (isValid) {
        const result = {
          departmentIds: [],
          designationIds: [],
        };

        rows.forEach((item) => {
          if (item.eligiblity_type === "Department") {
            result.departmentIds = item.departments.map((d) => d.id);
          } else if (item.eligiblity_type === "Designation") {
            result.designationIds = item.departments.map((d) => d.id);
          } else if (item.eligiblity_type === "Role") {
            result.roleIds = item.departments.map((d) => d.id);
          } else if (item.eligiblity_type === "Individual") {
            result.individualIds = item.departments.map((d) => d.id);
          } else if (item.eligiblity_type === "Payrollgroup") {
            result.payrollGroupIds = item.departments.map((d) => d.id);
          }
        });
        const response = await customAPI(
          `${domain}eligible-employee/preview/`,
          "POST",
          {
            group_id: selectedIncentive?.incentive_group,
            eligibilities: {
              DEPARTMENT: result.departmentIds,
              DESIGNATION: result.designationIds,
              ROLE: result.roleIds,
              INDIVIDUAL: result.individualIds,
              PAYROLLGROUP: result.payrollGroupIds,
            },
          }
        );
        if (response.ok) {
          setValue("Apply_criteria", false);
          setGetEmployeeCount(response?.responseDetails);
          setEligibleEmployee(response?.responseDetails?.eligible_employees);
          if (
            selectedIncentive?.incentive_type === "Custom" &&
            getdeptEmployee
          ) {
            setEligibleMetEmployee(
              response?.responseDetails?.eligible_employees
            );
            setRemovedEmployees([]);
          }
        }
      }
    };
    if (
      startDate !== null &&
      endDate !== null &&
      selectedIncentive?.id &&
      callPostApi
    ) {
      togetEligibleEmployess();
      setCallPostApi(false);
    }
  }, [
    callPostApi,
    domain,
    endDate,
    getdeptEmployee,
    rows,
    selectedIncentive,
    setValue,
    startDate,
    validateRows,
    watch,
  ]);

  useEffect(() => {
    const hanldeApplyCriteria = async () => {
      let isValid = await validateRows();
      if (isValid) {
        const result = {
          departmentIds: [],
          designationIds: [],
        };

        const slap = slapBasedConfigurations.map((data) => ({
          ...data,
          from_value: parseInt(data?.from_value),
          to_value: parseInt(data?.to_value),
          amount: parseFloat(data.amount),
        }));
        rows.forEach((item) => {
          if (item.eligiblity_type === "Department") {
            result.departmentIds = item.departments.map((d) => d.id);
          } else if (item.eligiblity_type === "Designation") {
            result.designationIds = item.departments.map((d) => d.id);
          } else if (item.eligiblity_type === "Role") {
            result.roleIds = item.departments.map((d) => d.id);
          } else if (item.eligiblity_type === "Individual") {
            result.individualIds = item.departments.map((d) => d.id);
          } else if (item.eligiblity_type === "Payrollgroup") {
            result.payrollGroupIds = item.departments.map((d) => d.id);
          }
        });
        const response = await customAPI(
          `${domain}eligible-met-employee/preview/`,
          "POST",
          {
            group_id: selectedIncentive?.incentive_group,
            start_date: startDate.format("YYYY-MM-DD"),
            end_date: endDate.format("YYYY-MM-DD"),
            criteria_type: selectedIncentive?.criteria_type,
            criteria_value:
              selectedIncentive?.criteria_type === "Percentage"
                ? watch("criteria_percentage")
                : watch("criteria_count"),
            fixed_amount:
              selectedIncentive?.calculation_mode === "FIXED"
                ? watch("fixed_amount")
                : null,
            percentage:
              selectedIncentive?.calculation_mode === "PERCENTAGE"
                ? watch("incentive_percentage")
                : null,
            slabs: selectedIncentive?.calculation_mode === "SLAB" ? slap : [],
            eligibilities: {
              DEPARTMENT: result.departmentIds,
              DESIGNATION: result.designationIds,
              ROLE: result.roleIds,
              INDIVIDUAL: result.individualIds,
              PAYROLLGROUP: result.payrollGroupIds,
            },
          }
        );
        if (response.ok) {
          setValue(
            "qualified_members",
            response?.responseDetails?.total_eligible_employees
          );
          setQualifiedMembersList(
            response?.responseDetails?.eligible_employees
          );
          setRemovedEmployees([]);
          if (watch("get_employee")) {
            return true;
          } else {
            setEligibleMetEmployee(
              response?.responseDetails?.eligible_employees
            );
          }
          setValue("value_changed", false);
        }
      }
    };
    if (
      startDate !== null &&
      endDate !== null &&
      selectedIncentive?.id &&
      trigerCriteriaApi
    ) {
      hanldeApplyCriteria();
      setTriggerCriteriaApi(false);
    }
  }, [
    callPostApi,
    domain,
    endDate,
    getEligibleEmployee,
    rows,
    selectedIncentive,
    setValue,
    slapBasedConfigurations,
    startDate,
    trigerCriteriaApi,
    validateRows,
    watch,
  ]);

  const validateDateRange = () => {
    if (startDate === null || endDate === null) {
      setValue("date_error", true);
    } else {
      setValue("date_error", false);
    }
  };

  const handleFixedAmount = (event) => {
    if (
      /^$|^\d{0,10}(\.\d{0,2})?$/.test(event.target.value) &&
      event.target.value.length <= 13
    ) {
      setValue("fixed_amount", event.target.value);
      setValue("value_changed", true);
    }
  };

  const handleIncentivePercentage = (event) => {
    if (
      /^(100(\.0{0,2})?|(\d{1,2})(\.\d{0,2})?)$/.test(event.target.value) ||
      event.target.value === ""
    ) {
      setValue("incentive_percentage", event.target.value);
      setValue("value_changed", true);
    }
  };

  const validateEachValueisGreater = () => {
    const ranges = slapBasedConfigurations.map((row) => {
      const from = Number(row.from_value);
      const to = Number(row.to_value);
      if (isNaN(from) || isNaN(to) || from >= to) {
        return null;
      }
      return { from, to };
    });
    if (ranges.includes(null)) return true;
    for (let i = 0; i < ranges.length; i++) {
      const a = ranges[i];
      for (let j = i + 1; j < ranges.length; j++) {
        const b = ranges[j];
        if (b.from <= a.to) {
          return true;
        }
      }
    }
    return false;
  };

  const isValidDateRanges = () => {
    const allValues = slapBasedConfigurations.flatMap((item) => [
      item.from_value,
      item.to_value,
    ]);
    const duplicates = allValues.filter(
      (val, index, arr) => arr.indexOf(val) !== index
    );
    if (duplicates.length > 0) {
      setAmountError(false);
      setFromDateError(false);
      setToDateError(false);
      setSlabError(true);
      return false;
    }
    if (validateEachValueisGreater()) {
      setAmountError(false);
      setFromDateError(false);
      setToDateError(false);
      setSlabError(true);
      return false;
    }

    for (const range of slapBasedConfigurations) {
      if (
        range?.amount === "" ||
        range?.amount === "0" ||
        (parseFloat(range?.amount) === 0 &&
          range?.from_value === "" &&
          range?.to_value === "")
      ) {
        setAmountError(true);
        setFromDateError(false);
        setToDateError(false);
        return false;
      } else if (range?.amount === "" || range?.amount === "0") {
        setAmountError(true);
        return false;
      } else if (range?.from_value === "" || range?.from_value === "0") {
        setFromDateError(true);
        return false;
      } else if (range?.to_value === "" || range?.to_value === "0") {
        setToDateError(true);
        return false;
      }
    }

    const sorted = [...slapBasedConfigurations].sort(
      (a, b) => parseInt(a.from_value) - parseInt(b.from_value)
    );
    for (let i = 0; i < sorted.length - 1; i++) {
      if (parseInt(sorted[i].to_value) > parseInt(sorted[i + 1].from_value)) {
        setSlabError(true);
        setAmountError(false);
        setFromDateError(false);
        setToDateError(false);
        return false;
      }
    }
    setSlabError(false);
    setAmountError(false);
    return true;
  };

  const addSlapbasedConfigurations = () => {
    if (isValidDateRanges()) {
      setSlapbasedConfigurations([
        ...slapBasedConfigurations,
        {
          id: count + 1,
          from_value: "",
          to_value: "",
          amount: "0",
        },
      ]);
      setFromDateError(false);
      setToDateError(false);
      setAmountError(false);
    }
  };

  const removeSlashbasedConfigurations = (id) => {
    let slashbased = slapBasedConfigurations.filter((data) => {
      return data?.id !== id;
    });
    setSlapbasedConfigurations(slashbased);
  };

  const handleFromDate = (val, row) => {
    const slap = slapBasedConfigurations.map((data) =>
      row.id === data?.id ? { ...data, from_value: val } : data
    );
    setSlapbasedConfigurations(slap);
    setValue("value_changed", true);
  };

  const handleToDate = (val, row) => {
    const slap = slapBasedConfigurations.map((data) =>
      row.id === data?.id ? { ...data, to_value: val } : data
    );
    setSlapbasedConfigurations(slap);
    setValue("value_changed", true);
  };

  const handleAmount = (val, row) => {
    const slap = slapBasedConfigurations.map((data) =>
      row.id === data?.id ? { ...data, amount: val } : data
    );
    setSlapbasedConfigurations(slap);
    setValue("value_changed", true);
  };

  useEffect(() => {
    if (
      EligibleMetDetials?.employees?.length !== 0 &&
      getEligibleEmployee &&
      EligibleMetDetials?.length !== 0
    ) {
      setEligibleMetEmployee(EligibleMetDetials?.employees);
      setGetEligibleEmployee(false);
    }
  }, [
    EligibleMetDetials?.employees,
    EligibleMetDetials?.length,
    getEligibleEmployee,
  ]);

  useEffect(() => {
    if (
      watch("get_removed_employee") &&
      qualifiedMembersList?.length !== 0 &&
      EligibleMetDetials?.length !== 0 &&
      EligibleMetDetials?.employees?.length !== 0
    ) {
      setValue("get_removed_employee", false);
      const notInListB = qualifiedMembersList?.filter(
        (aItem) =>
          !EligibleMetDetials?.employees?.some(
            (bItem) => bItem.user === aItem.user
          )
      );

      setRemovedEmployees(notInListB);
    }
  }, [EligibleMetDetials, qualifiedMembersList, setValue, watch]);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Mui.Grid
        container
        sx={{
          paddingTop: "3%",
          paddingLeft: "5%",
          paddingRight: "5%",
        }}
      >
        <Mui.Grid
          container
          sx={{
            padding: 1,
            backgroundColor: themes.primary,
            borderRadius: "10px 10px 0 0",
            border: `2px solid ${themes.sidebarDivider}`,
            borderBottom: "none",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Mui.Typography
            sx={{
              fontSize: 24,
              fontWeight: 800,
              font: "bold",
              textAlign: "center",
            }}
          >
            Edit Incentive
          </Mui.Typography>
        </Mui.Grid>
        <Mui.Grid
          container
          sx={{
            paddingTop: -1,
            border: `2px solid ${themes.sidebarDivider}`,
            padding: 2,
            borderRadius: "0 0 10px 10px",
          }}
        >
          <Mui.Grid container sx={{ paddingTop: 1 }}>
            <Mui.Grid xs={4}>
              <Mui.Typography sx={formText}>
                Incentive Name&nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Review and update the incentive name if needed. This helps clearly identify the purpose of the incentive."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
            </Mui.Grid>
            <Mui.Grid xs={0.2}></Mui.Grid>
            <Mui.Grid xs={7} sx={{ mt: 1.8 }}>
              <Mui.Typography sx={{ fontSize: 18, fontWeight: "bold" }}>
                {watch("incentive_name")}
              </Mui.Typography>
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid container sx={{ paddingTop: 1 }}>
            <Mui.Grid xs={4}>
              <Mui.Typography sx={formText}>
                Incentive Type&nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Displays the category assigned to the incentive (e.g., Attendance, Performance). Not editable in this screen."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
            </Mui.Grid>
            <Mui.Grid xs={0.2}></Mui.Grid>
            <Mui.Grid xs={7} sx={{ mt: 2 }}>
              <Mui.Typography sx={{ fontSize: 18, fontWeight: "bold" }}>
                {selectedIncentive?.incentive_type}
              </Mui.Typography>
            </Mui.Grid>
          </Mui.Grid>
          {selectedIncentive?.incentive_type !== "Custom" && (
            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid xs={4}>
                <Mui.Typography sx={formText}>
                  Calculation Mode&nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Indicates how the incentive is configured—Fixed Amount, % of Salary, or Slab Based. Shown for reference."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={0.2}></Mui.Grid>
              <Mui.Grid xs={7} sx={{ mt: 2 }}>
                <Mui.Typography sx={{ fontSize: 18, fontWeight: "bold" }}>
                  {selectedIncentive?.calculation_mode === "PERCENTAGE"
                    ? "Percentage"
                    : selectedIncentive?.calculation_mode === "SLAB"
                    ? "Slab based"
                    : "Fixed Amount"}
                </Mui.Typography>
              </Mui.Grid>
            </Mui.Grid>
          )}
          <Mui.Grid
            container
            sx={{
              border: `3px solid ${themes.sidebarDivider}`,
              borderRadius: 2,
              mt: 2,
            }}
          >
            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid xs={4}>
                <Mui.Typography sx={formText}>
                  Eligibility&nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Adjust the eligible group filters (like Department or Designation). Add or remove criteria using the + or ✖ icons."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={0.2}></Mui.Grid>
              <Mui.Grid xs={7} sx={{ mt: 0.5 }}>
                <Mui.TableContainer
                  sx={{
                    width: "100%",
                  }}
                >
                  <Mui.Table className="border">
                    {rows.map((row, index) => {
                      const selectedDepartments = rows
                        .filter((_, i) => i !== index)
                        .map((r) => r.eligiblity_type)
                        .filter(Boolean);

                      return (
                        <Mui.TableBody key={index}>
                          <Mui.TableCell sx={{ width: "50%" }}>
                            <Mui.Autocomplete
                              disablePortal
                              id={`min-percentage-${index}`}
                              size="small"
                              value={row.eligiblity_type}
                              options={EligibilityType?.map((obj) => ({
                                ...obj,
                                label: obj?.name,
                              }))}
                              getOptionDisabled={(option) =>
                                selectedDepartments.includes(option.name)
                              }
                              renderOption={(props, option) => {
                                return <li {...props}>{option.label}</li>;
                              }}
                              filterOptions={(options, state) =>
                                options?.filter((option) =>
                                  option.label
                                    ?.toLowerCase()
                                    ?.includes(state.inputValue.toLowerCase())
                                )
                              }
                              sx={{ width: "100%" }}
                              ListboxProps={{
                                style: {
                                  maxHeight: "150px",
                                },
                              }}
                              onChange={(event, value) => {
                                if (value) {
                                  handleChange(
                                    index,
                                    "eligiblity_type",
                                    value.name
                                  );
                                  handleChange(index, "departments", []);
                                }
                              }}
                              renderInput={(params) => (
                                <Mui.TextField
                                  {...params}
                                  sx={{ background: themes.whiteColor }}
                                  placeholder="Select eligibility type"
                                  size="small"
                                  error={
                                    rowError?.[index]?.eligiblity_type || false
                                  }
                                  helperText={
                                    rowError[index]?.eligiblity_type
                                      ? row.eligiblity_type.trim() === ""
                                        ? "Select eligibility type"
                                        : ""
                                      : ""
                                  }
                                />
                              )}
                            />
                          </Mui.TableCell>

                          <Mui.TableCell sx={{ width: "50%" }}>
                            <Mui.Autocomplete
                              multiple
                              id={`departments-${index}`}
                              size="small"
                              limitTags={1}
                              disableCloseOnSelect
                              options={
                                row?.eligiblity_type === "Department"
                                  ? departmentList
                                  : row?.eligiblity_type === "Designation"
                                  ? designationList
                                  : row?.eligiblity_type === "Role"
                                  ? roleList
                                  : row?.eligiblity_type === "Individual"
                                  ? individualList
                                  : row?.eligiblity_type === "Payrollgroup"
                                  ? payrollGroupList
                                  : []
                              }
                              value={row.departments || []}
                              getOptionLabel={(option) => option.name}
                              isOptionEqualToValue={(option, value) =>
                                option.id === value.id
                              }
                              ListboxProps={{
                                style: {
                                  maxHeight: "200px",
                                },
                              }}
                              onChange={(event, value) => {
                                handleChange(index, "departments", value);
                              }}
                              renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                  <li key={key} {...optionProps}>
                                    <Mui.Checkbox
                                      icon={
                                        <Icons.CheckBoxOutlineBlank fontSize="small" />
                                      }
                                      checkedIcon={
                                        <Icons.CheckBox fontSize="small" />
                                      }
                                      checked={selected}
                                    />
                                    {option.name}
                                  </li>
                                );
                              }}
                              renderInput={(params) => (
                                <Mui.TextField
                                  {...params}
                                  multiline
                                  rows={1}
                                  maxRows={1}
                                  error={
                                    rowError?.[index]?.departments || false
                                  }
                                  helperText={
                                    rowError[index]?.departments
                                      ? row.departments?.length === 0
                                        ? row?.eligiblity_type === "Department"
                                          ? "Select the department"
                                          : row?.eligiblity_type ===
                                            "Designation"
                                          ? "Select the designation"
                                          : row?.eligiblity_type === "Role"
                                          ? "Select the role"
                                          : row?.eligiblity_type ===
                                            "Individual"
                                          ? "Select the user"
                                          : row?.eligiblity_type ===
                                            "Payrollgroup"
                                          ? "Select the payroll group"
                                          : "Select the value"
                                        : ""
                                      : ""
                                  }
                                  placeholder={
                                    row?.departments?.length === 0
                                      ? row?.eligiblity_type === "Department"
                                        ? "Select the department"
                                        : row?.eligiblity_type === "Designation"
                                        ? "Select the designation"
                                        : row?.eligiblity_type === "Role"
                                        ? "Select the role"
                                        : row?.eligiblity_type === "Individual"
                                        ? "Select the user"
                                        : row?.eligiblity_type ===
                                          "Payrollgroup"
                                        ? "Select the payroll group"
                                        : "Select the value"
                                      : ""
                                  }
                                  InputProps={{
                                    ...params.InputProps,
                                  }}
                                />
                              )}
                            />
                          </Mui.TableCell>

                          <Mui.TableCell>
                            <Mui.Tooltip
                              arrow
                              slotProps={tooltipStyleProps}
                              title={"Remove"}
                            >
                              <Mui.IconButton
                                onClick={() => {
                                  handleRemoveRow(index);
                                  setCallPostApi(true);
                                  setValue("value_changed", true);
                                  setValue("apply_criteria", false);
                                }}
                                disabled={rows?.length === 1}
                              >
                                <Cancel
                                  sx={{
                                    color:
                                      rows?.length === 1
                                        ? themes?.disable
                                        : themes?.redColor,
                                  }}
                                />
                              </Mui.IconButton>
                            </Mui.Tooltip>
                          </Mui.TableCell>
                        </Mui.TableBody>
                      );
                    })}
                  </Mui.Table>
                </Mui.TableContainer>
                <Mui.Grid container>
                  <Mui.Grid item xs={11.1}></Mui.Grid>
                  <Mui.Grid item xs={0.9}>
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title={"Add Row"}
                    >
                      <Mui.IconButton onClick={handleAddRow}>
                        <AddCircle sx={{ color: themes.primaryIndicator }} />
                      </Mui.IconButton>
                    </Mui.Tooltip>
                  </Mui.Grid>
                </Mui.Grid>
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid xs={4}>
                <Mui.Typography sx={formText}>
                  Eligible Members&nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Auto-generated count of employees matching the current eligibility conditions. Not editable manually."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={0.2}></Mui.Grid>
              <Mui.Grid xs={3} sx={{ mt: 2 }}>
                <Mui.Typography sx={{ fontSize: 18, fontWeight: "bold" }}>
                  {getEmployeeCount?.total_eligible_employees ?? "0"}
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid
                xs={4}
                sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}
              >
                <CustomButtonWithOutLoader
                  actionName="View Details"
                  typeName="button"
                  actionFuntion={() => {
                    setValue("eligible_employee", true);
                    setOpenSidePeek(true);
                  }}
                  customWidth={true}
                />
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container sx={{ mt: 1.5 }}></Mui.Grid>
          </Mui.Grid>

          <Mui.Grid
            container
            sx={{
              border: `3px solid ${themes.sidebarDivider}`,
              borderRadius: 2,
              mt: 2,
            }}
          >
            {selectedIncentive?.incentive_type === "Custom" ||
            selectedIncentive?.calculation_mode === "SLAB" ? null : (
              <Mui.Grid container sx={{ paddingTop: 1 }}>
                <Mui.Grid xs={4}>
                  <Mui.Typography sx={formText}>
                    Criteria Type &nbsp;
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title="Shows the type of performance measurement used—Percentage or Count."
                    >
                      <Info />
                    </Mui.Tooltip>
                  </Mui.Typography>
                </Mui.Grid>
                <Mui.Grid xs={0.2}></Mui.Grid>
                <Mui.Grid xs={7} sx={{ mt: 2 }}>
                  <Mui.Typography sx={{ fontSize: 18, fontWeight: "bold" }}>
                    {selectedIncentive?.criteria_type}
                  </Mui.Typography>
                </Mui.Grid>
              </Mui.Grid>
            )}

            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid xs={4}>
                <Mui.Typography sx={formText}>
                  Date Range&nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Modify the date range during which the incentive is applicable."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={0.2}></Mui.Grid>
              <Mui.Grid xs={7} sx={{ mt: 1 }}>
                <DateRangePicker
                  initialSettings={{
                    startDate: startDate.toDate(),
                    endDate: endDate.toDate(),
                    applyClass: "custom-apply-btn",
                    cancelClass: "custom-cancel-btn",
                    maxDate: moment(),
                    locale: {
                      format: "DD/MM/YYYY",
                    },
                  }}
                  onCallback={handleCallback}
                >
                  <Mui.TextField
                    id="reportrange"
                    variant="outlined"
                    label=""
                    placeholder="Select a date range"
                    value={label}
                    size="small"
                    InputProps={{
                      readOnly: true,
                      notched: false,
                      endAdornment: (
                        <Mui.InputAdornment position="end">
                          <Mui.IconButton>
                            <DateRange />
                          </Mui.IconButton>
                        </Mui.InputAdornment>
                      ),
                    }}
                    InputLabelProps={{ shrink: true, required: true }}
                    fullWidth
                    sx={{
                      "& .MuiOutlinedInput-notchedOutline": {
                        legend: {
                          display: "none",
                        },
                      },
                    }}
                  />
                </DateRangePicker>
              </Mui.Grid>
            </Mui.Grid>

            {selectedIncentive?.incentive_type === "Custom" ||
            selectedIncentive?.calculation_mode === "SLAB" ? null : (
              <Mui.Grid container sx={{ paddingTop: 1 }}>
                <Mui.Grid xs={4} sx={{ paddingTop: 1 }}>
                  <Mui.Typography sx={formText}>
                    {selectedIncentive?.criteria_type === "Count"
                      ? "Criteria Count"
                      : "Criteria Percentage (%)"}
                    &nbsp;
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title={
                        selectedIncentive?.criteria_type === "Count"
                          ? "Update the required count value employees need to meet for eligibility."
                          : "Update the performance threshold (in percentage) employees must meet to qualify for the incentive."
                      }
                    >
                      <Info />
                    </Mui.Tooltip>
                  </Mui.Typography>
                </Mui.Grid>
                <Mui.Grid xs={0.2}></Mui.Grid>
                <Mui.Grid xs={7} sx={{ mt: 2 }}>
                  {selectedIncentive?.criteria_type === "Count" ? (
                    <CustomTextBox
                      selectedValue={watch("criteria_count")}
                      rules={{
                        ...register("criteria_count", {
                          required: false,
                          validate: {
                            minLengthNoSpaces: (value) => {
                              if (
                                selectedIncentive?.criteria_type === "Count" &&
                                (!watch("criteria_count") ||
                                  watch("criteria_count") === "0")
                              ) {
                                return "Count is required";
                              } else {
                                return true;
                              }
                            },
                          },
                        }),
                      }}
                      updateDataFunction={handleCritriaCount}
                      placeHolder="Enter the count"
                      errorMessage={
                        errors?.criteria_count?.message
                          ? errors?.criteria_count?.message
                          : ""
                      }
                      textBoxError={errors.criteria_count ? true : false}
                    />
                  ) : (
                    <CustomTextBox
                      selectedValue={watch("criteria_percentage")}
                      rules={{
                        ...register("criteria_percentage", {
                          required: false,
                          validate: {
                            minLengthNoSpaces: (value) => {
                              if (
                                selectedIncentive?.criteria_type ===
                                  "Percentage" &&
                                (!watch("criteria_percentage") ||
                                  watch("criteria_percentage") === "0")
                              ) {
                                return "Percentage is required";
                              } else {
                                return true;
                              }
                            },
                          },
                        }),
                      }}
                      updateDataFunction={handleCritriaPercentage}
                      placeHolder="Enter the percentage"
                      errorMessage={
                        errors?.criteria_percentage?.message
                          ? errors?.criteria_percentage?.message
                          : ""
                      }
                      textBoxError={errors.criteria_percentage ? true : false}
                    />
                  )}
                </Mui.Grid>
              </Mui.Grid>
            )}

            {selectedIncentive?.calculation_mode !== "SLAB" &&
              selectedIncentive?.incentive_type !== "Custom" && (
                <Mui.Grid container sx={{ paddingTop: 1 }}>
                  <Mui.Grid xs={4}>
                    <Mui.Typography sx={formText}>
                      {selectedIncentive?.calculation_mode === "PERCENTAGE"
                        ? "Enter Percentage"
                        : selectedIncentive?.calculation_mode === "SLAB"
                        ? "Slab based"
                        : "Enter Amount"}
                      &nbsp;
                      <Mui.Tooltip
                        arrow
                        slotProps={tooltipStyleProps}
                        title="Displays the fixed value assigned for each eligible employee."
                      >
                        <Info />
                      </Mui.Tooltip>
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={0.2}></Mui.Grid>
                  <Mui.Grid xs={3} sx={{ mt: 2 }}>
                    {watch("mode") === "FIXED" ? (
                      <CustomTextBox
                        selectedValue={watch("fixed_amount")}
                        rules={{
                          ...register("fixed_amount", {
                            required: false,
                            validate: {
                              minLengthNoSpaces: (value) => {
                                if (
                                  watch("mode") === "FIXED" &&
                                  (!watch("fixed_amount") ||
                                    watch("fixed_amount") === "0")
                                ) {
                                  return "Fixed amount is required";
                                } else {
                                  return true;
                                }
                              },
                            },
                          }),
                        }}
                        updateDataFunction={handleFixedAmount}
                        placeHolder="Enter the fixed amount"
                        errorMessage={
                          errors?.fixed_amount?.message
                            ? errors?.fixed_amount?.message
                            : ""
                        }
                        textBoxError={errors.fixed_amount ? true : false}
                      />
                    ) : watch("mode") === "PERCENTAGE" ? (
                      <CustomTextBox
                        selectedValue={watch("incentive_percentage")}
                        rules={{
                          ...register("incentive_percentage", {
                            required: false,
                            validate: {
                              minLengthNoSpaces: (value) => {
                                if (
                                  watch("mode") === "PERCENTAGE" &&
                                  (!watch("incentive_percentage") ||
                                    watch("incentive_percentage") === "0")
                                ) {
                                  return "Percentage is required";
                                } else {
                                  return true;
                                }
                              },
                            },
                          }),
                        }}
                        updateDataFunction={handleIncentivePercentage}
                        placeHolder="Enter the percentage"
                        errorMessage={
                          errors?.incentive_percentage?.message
                            ? errors?.incentive_percentage?.message
                            : ""
                        }
                        textBoxError={
                          errors.incentive_percentage ? true : false
                        }
                      />
                    ) : null}
                  </Mui.Grid>
                  <Mui.Grid
                    xs={4}
                    sx={{
                      mt: 2,
                      display: "flex",
                      justifyContent: "flex-end",
                      minHeight: 20,
                      maxHeight: 40,
                    }}
                  >
                    <CustomButtonWithOutLoader
                      actionName="Apply Criteria"
                      typeName="button"
                      actionFuntion={async () => {
                        const isValid = await trigger([
                          "fixed_amount",
                          "incentive_percentage",
                          "criteria_percentage",
                          "criteria_count",
                        ]);
                        if (access_check && isValid && startDate !== null) {
                          setValue("get_employee", false);
                          setTriggerCriteriaApi(true);
                        } else if (!access_check) {
                          showToast(
                            "error",
                            "Access denied: You are not authorized to apply the incentive"
                          );
                        }
                      }}
                      disableAction={!ValueChanged}
                    />
                  </Mui.Grid>
                </Mui.Grid>
              )}

            {selectedIncentive?.calculation_mode === "SLAB" &&
              selectedIncentive?.incentive_type !== "Custom" && (
                <Mui.Grid container sx={{ paddingTop: 1 }}>
                  <Mui.Grid xs={4}>
                    <Mui.Typography sx={formText}>
                      Slab based&nbsp;
                      <Mui.Tooltip
                        arrow
                        slotProps={tooltipStyleProps}
                        title="Incentives are calculated based on performance ranges (slabs). Higher performance falls into higher slabs with better rewards."
                      >
                        <Info />
                      </Mui.Tooltip>
                    </Mui.Typography>
                  </Mui.Grid>
                  <Mui.Grid xs={0.2}></Mui.Grid>
                  <Mui.Grid xs={7} sx={{ mt: 2 }}>
                    <Mui.TableContainer
                      component={Mui.Paper}
                      sx={{
                        border: `2px solid ${themes.sidebarDivider}`,
                        borderRadius: "10px",
                      }}
                    >
                      <Mui.Table>
                        <Mui.TableHead>
                          <Mui.TableRow
                            sx={{
                              "& .MuiTableCell-root": {
                                height: "10px",
                                padding: "6px 5px",
                              },
                              backgroundColor: themes.primary,
                            }}
                          >
                            <Mui.TableCell
                              align="center"
                              sx={{
                                color: themes.headLine,
                                fontWeight: "bold",
                              }}
                              colSpan={12}
                            >
                              <Mui.Grid container>
                                <Mui.Grid xs={3.5}>
                                  <Mui.Typography
                                    sx={{
                                      color: themes.headLine,
                                      fontWeight: "bold",
                                    }}
                                  >
                                    From
                                  </Mui.Typography>
                                </Mui.Grid>
                                <Mui.Grid xs={3.5}>
                                  <Mui.Typography
                                    sx={{
                                      color: themes.headLine,
                                      fontWeight: "bold",
                                    }}
                                  >
                                    To
                                  </Mui.Typography>
                                </Mui.Grid>
                                <Mui.Grid xs={3.5}>
                                  <Mui.Typography
                                    sx={{
                                      color: themes.headLine,
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Amount
                                  </Mui.Typography>
                                </Mui.Grid>
                                <Mui.Grid xs={1.5}>Action</Mui.Grid>
                              </Mui.Grid>
                            </Mui.TableCell>
                          </Mui.TableRow>
                        </Mui.TableHead>
                        <Mui.TableBody>
                          {slapBasedConfigurations?.map((row) => (
                            <Mui.TableRow
                              key={row.id}
                              sx={{
                                "& .MuiTableCell-root": {
                                  height: "10px",
                                  padding: "6px 5px",
                                },
                              }}
                            >
                              <Mui.TableCell
                                align="center"
                                sx={{
                                  color: themes.headLine,
                                  fontWeight: "bold",
                                }}
                                colSpan={12}
                              >
                                <Mui.Grid container>
                                  <Mui.Grid xs={3.5} sx={{ padding: 0.2 }}>
                                    <Mui.TextField
                                      size="small"
                                      value={row?.from_value}
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        const validPattern = /^\d+$/;
                                        if (
                                          val === "" ||
                                          validPattern.test(val)
                                        ) {
                                          handleFromDate(val, row);
                                        }
                                      }}
                                      placeholder="Enter from day"
                                      error={
                                        fromDateError && row?.from_value === ""
                                      }
                                      helperText={
                                        fromDateError && row?.from_value === ""
                                          ? "Enter from day"
                                          : null
                                      }
                                    />
                                  </Mui.Grid>
                                  <Mui.Grid xs={3.5} sx={{ padding: 0.2 }}>
                                    <Mui.TextField
                                      size="small"
                                      value={row?.to_value}
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        const validPattern = /^\d+$/;
                                        if (
                                          val === "" ||
                                          validPattern.test(val)
                                        ) {
                                          handleToDate(val, row);
                                        }
                                      }}
                                      error={
                                        toDateError && row?.to_value === ""
                                      }
                                      helperText={
                                        toDateError && row?.to_value === ""
                                          ? "Enter to day"
                                          : null
                                      }
                                      placeholder="Enter to day"
                                    />
                                  </Mui.Grid>
                                  <Mui.Grid xs={3.5} sx={{ padding: 0.2 }}>
                                    <Mui.TextField
                                      size="small"
                                      value={row?.amount}
                                      onChange={(e) => {
                                        const val = e.target.value;
                                        const validPattern =
                                          /^$|^\d{0,10}(\.\d{0,2})?$/;
                                        if (
                                          val === "" ||
                                          validPattern.test(val)
                                        ) {
                                          handleAmount(val, row);
                                        }
                                      }}
                                      placeholder="Enter amount"
                                      error={
                                        amountError &&
                                        (row?.amount === "" ||
                                          row.amount === "0")
                                      }
                                      helperText={
                                        amountError &&
                                        (row?.amount === "" ||
                                          row.amount === "0")
                                          ? "Enter the amount"
                                          : null
                                      }
                                    />
                                  </Mui.Grid>
                                  <Mui.Grid xs={1.5} sx={{ padding: 0.2 }}>
                                    <Mui.IconButton
                                      size="small"
                                      onClick={() =>
                                        removeSlashbasedConfigurations(row.id)
                                      }
                                      disabled={
                                        slapBasedConfigurations.length === 1
                                      }
                                    >
                                      <Close size="small" />
                                    </Mui.IconButton>
                                  </Mui.Grid>
                                </Mui.Grid>
                              </Mui.TableCell>
                            </Mui.TableRow>
                          ))}
                          <Mui.TableRow
                            sx={{
                              "& .MuiTableCell-root": {
                                height: "6px",
                                padding: "3px 3px",
                              },
                            }}
                          >
                            <Mui.TableCell>
                              <Mui.Tooltip
                                arrow
                                slotProps={tooltipStyleProps}
                                title={"Add Row"}
                              >
                                <Mui.IconButton
                                  onClick={() => addSlapbasedConfigurations()}
                                >
                                  <AddCircle
                                    sx={{ color: themes.primaryIndicator }}
                                  />
                                </Mui.IconButton>
                              </Mui.Tooltip>
                            </Mui.TableCell>
                          </Mui.TableRow>
                        </Mui.TableBody>
                      </Mui.Table>
                    </Mui.TableContainer>
                    {slabError &&
                    selectedIncentive?.calculation_mode === "SLAB" ? (
                      <Mui.Grid container sx={{ paddingLeft: 2 }}>
                        <Mui.Typography
                          variant="body2"
                          color="error"
                          sx={{
                            fontSize: 13,
                            paddingTop: 0.5,
                          }}
                        >
                          Ensure that each entry has a FROM value that is less
                          than the TO value.
                        </Mui.Typography>
                      </Mui.Grid>
                    ) : null}
                  </Mui.Grid>
                  <Mui.Grid
                    xs={11.2}
                    sx={{
                      mt: 2,
                      display: "flex",
                      justifyContent: "flex-end",
                      minHeight: 20,
                      maxHeight: 40,
                    }}
                  >
                    <CustomButtonWithOutLoader
                      actionName="Apply Criteria"
                      // disableAction={watchApplyApi}
                      typeName="button"
                      actionFuntion={async () => {
                        const isValid = await trigger([
                          "fixed_amount",
                          "incentive_percentage",
                          "criteria_percentage",
                          "criteria_count",
                        ]);
                        validateDateRange();
                        isValidDateRanges();
                        if (
                          access_check &&
                          isValid &&
                          startDate !== null &&
                          !slabError
                        ) {
                          setValue("get_employee", false);
                          setTriggerCriteriaApi(true);
                        } else if (!access_check) {
                          showToast(
                            "error",
                            "Access denied: You are not authorized to apply the incentive"
                          );
                        }
                      }}
                      disableAction={!ValueChanged}
                    />
                  </Mui.Grid>
                </Mui.Grid>
              )}

            {selectedIncentive?.incentive_type !== "Custom" && (
              <Mui.Grid container sx={{ paddingTop: 1 }}>
                <Mui.Grid xs={4}>
                  <Mui.Typography sx={formText}>
                    Qualified Members &nbsp;
                    <Mui.Tooltip
                      arrow
                      slotProps={tooltipStyleProps}
                      title="System-calculated value showing how many employees satisfy the defined criteria."
                    >
                      <Info />
                    </Mui.Tooltip>
                  </Mui.Typography>
                </Mui.Grid>
                <Mui.Grid xs={0.2}></Mui.Grid>
                <Mui.Grid xs={3} sx={{ mt: 2 }}>
                  <Mui.Typography sx={{ fontSize: 18, fontWeight: "bold" }}>
                    {qualifiedMembers}
                  </Mui.Typography>
                </Mui.Grid>

                <Mui.Grid
                  xs={4}
                  sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}
                >
                  <CustomButtonWithOutLoader
                    actionName="View Details"
                    typeName="button"
                    actionFuntion={() => {
                      setValue("qualified_employee", true);
                      setOpenSidePeek(true);
                    }}
                    disableAction={
                      ValueChanged ||
                      qualifiedMembers === 0 ||
                      qualifiedMembers === "0"
                    }
                    customWidth={true}
                  />
                </Mui.Grid>
              </Mui.Grid>
            )}
            <Mui.Grid container sx={{ mt: 1.5 }}></Mui.Grid>
          </Mui.Grid>

          <Mui.Grid
            container
            sx={{
              border: `3px solid ${themes.sidebarDivider}`,
              borderRadius: 2,
              mt: 2,
            }}
          >
            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid xs={4}>
                <Mui.Typography sx={formText}>
                  Members Selected For Incentive &nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Shows the number of employees who meet the set criteria and qualify for the incentive."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid xs={0.2}></Mui.Grid>
              <Mui.Grid xs={3} sx={{ mt: 2 }}>
                <Mui.Typography sx={{ fontSize: 18, fontWeight: "bold" }}>
                  {eligibleMetEmployee?.length}
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid
                xs={4}
                sx={{ mt: 2, display: "flex", justifyContent: "flex-end" }}
              >
                <CustomButtonWithOutLoader
                  actionName="View Details"
                  typeName="button"
                  actionFuntion={() => {
                    setValue("eligible_employee", false);
                    setValue("qualified_employee", false);
                    setOpenSidePeek(true);
                  }}
                  customWidth={true}
                  disableAction={
                    selectedIncentive?.incentive_type === "Custom"
                      ? false
                      : (eligibleMetEmployee?.length === 0 &&
                          removedEmployees?.length === 0) ||
                        ValueChanged
                  }
                />
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container sx={{ paddingTop: 1 }}>
              <Mui.Grid item xs={4}>
                <Mui.Typography sx={formText}>
                  Description &nbsp;
                  <Mui.Tooltip
                    arrow
                    slotProps={tooltipStyleProps}
                    title="Update or revise any notes to explain the reason for editing this incentive."
                  >
                    <Info />
                  </Mui.Tooltip>
                </Mui.Typography>
              </Mui.Grid>
              <Mui.Grid item xs={0.2}></Mui.Grid>
              <Mui.Grid item xs={7}>
                <CustomTextBox
                  type="multiline"
                  Rows={5}
                  rules={{
                    ...register("reason_for_incentive", {
                      required: "Description is required",
                      validate: {
                        minLengthNoSpaces: (value) => {
                          if (value?.trim().length < 3 && value !== "") {
                            return minimum3Characters;
                          } else if (
                            value?.trim().length > 255 &&
                            value !== ""
                          ) {
                            return "Maximum length is 255 characters";
                          } else {
                            return true;
                          }
                        },
                        atleastOneCharacterWithSpaceReg: (value) => {
                          if (
                            atleastOneCharacterWithSpace.test(value) ||
                            value === ""
                          ) {
                            return true;
                          } else {
                            return "Atleast one alphabet required";
                          }
                        },
                      },
                    }),
                  }}
                  selectedValue={watch("reason_for_incentive")}
                  updateDataFunction={updatedReasonForOvertime}
                  placeHolder="Provide a reason for incentive"
                  errorMessage={
                    errors?.reason_for_incentive?.message
                      ? errors?.reason_for_incentive?.message
                      : ""
                  }
                  textBoxError={errors?.reason_for_incentive ? true : false}
                />
              </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container sx={{ mt: 2 }}></Mui.Grid>
          </Mui.Grid>

          <Mui.Grid
            container
            xs={11.3}
            sx={{
              mt: 2,
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
              alignItems: "flex-end",
            }}
            spacing={1}
          >
            <Mui.Grid item>
              <CustomButton
                actionFuntion={() => {
                  setSelectedComponent("Pending");
                }}
                actionName="Cancel"
              />
              &nbsp;&nbsp;
              {selectedIncentive?.incentive_type !== "Custom" &&
              ValueChanged ? (
                <Mui.Tooltip
                  title="Values changed. Update apply criteria before submitting."
                  arrow
                  slotProps={tooltipStyleProps}
                >
                  <span style={{ display: "inline-block" }}>
                    <CustomButtonWithOutLoader
                      actionName="Update"
                      disableAction={ValueChanged}
                    />
                  </span>
                </Mui.Tooltip>
              ) : (
                <CustomButton
                  actionFuntion={() => {
                    const isValid = validateRows();
                    if (!isValid) return;
                  }}
                  actionName="Update"
                  typeName="submit"
                  disableAction={buttonLoader}
                />
              )}
            </Mui.Grid>
          </Mui.Grid>
        </Mui.Grid>
        {openSidePeek && (
          <Mui.Grid>
            <EmployeeDetails
              openSidePeek={openSidePeek}
              setOpenSidePeek={setOpenSidePeek}
              EmployeeCheck={EmployeeCheck}
              getEmployeeCount={getEmployeeCount}
              EligibleEmployee={EligibleEmployee}
              eligibleMetEmployee={eligibleMetEmployee}
              setEligibleMetEmployee={setEligibleMetEmployee}
              removedEmployees={removedEmployees}
              setRemovedEmployees={setRemovedEmployees}
              QualifiedCheck={QualifiedCheck}
              qualifiedMembersList={qualifiedMembersList}
              IncentiveType={IncentiveType}
              IncntiveName={selectedIncentive?.incentive_name}
            />
          </Mui.Grid>
        )}
        <Mui.Grid container sx={{ mt: 5 }}></Mui.Grid>
      </Mui.Grid>
    </form>
  );
};
